import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

interface Props {
  loading: boolean;
  data: number[];
  colors: string[];
  hoverColors?: string[];
  percentage: number;
  centerText: string;
  additionalInfo: { label: string; value: number }[];
}

export const DonutChart = (props: Props): JSX.Element => {
  const percentage =
    !Number.isFinite(props.percentage) || Number.isNaN(props.percentage)
      ? 0
      : props.percentage;

  const chartData = {
    labels: [],
    datasets: [
      {
        data: props.loading ? [0, 100] : props.data,
        backgroundColor: props.colors,
        hoverBackgroundColor: props.hoverColors,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: "60%",
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    responsive: true,
  };

  return (
    <div className="w-72 mx-auto relative text-center items-center">
      <div className="w-72 mx-auto relative text-center flex items-center">
        <Doughnut data={chartData} options={options} />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-xl font-bold pointer-events-none">
          <span className="text-4xl font-bold">
            {props.loading ? 0 : percentage}%
          </span>
          <br />
          <span className="text-base font-normal">{props.centerText}</span>
        </div>
      </div>
      <div className="mt-5 flex justify-around">
        {props.additionalInfo.map((info, index) => (
          <div key={index}>
            <p className="text-4xl font-bold m-0">{info.value}</p>
            <p className="text-base font-normal m-0">{info.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
